import { render } from "./DangerButton.vue?vue&type=template&id=50ea7c80"
import script from "./DangerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DangerButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/DangerButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50ea7c80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50ea7c80', __exports__)) {
    api.reload('50ea7c80', __exports__)
  }
  
  module.hot.accept("./DangerButton.vue?vue&type=template&id=50ea7c80", () => {
    api.rerender('50ea7c80', render)
  })

}


export default __exports__